var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "content-header",
      class: {
        "bg-type": _vm.bgType,
        "bg-height": _vm.bgHeight,
        "no-radius": _vm.noRadius,
        "mbtm-16": _vm.mbtm16,
        "mbtm-20": _vm.mbtm20,
        "mbtm-24": _vm.mbtm24,
        "mbtm-54": _vm.mbtm54,
        "bg-height2": _vm.titleImg2
      }
    },
    [
      _vm.title
        ? _c("div", { staticClass: "title" }, [
            _c("h2", { domProps: { innerHTML: _vm._s(_vm.$t(_vm.title)) } })
          ])
        : _vm._e(),
      _vm.description
        ? _c("div", {
            staticClass: "description",
            domProps: { innerHTML: _vm._s(_vm.$t(_vm.description)) }
          })
        : _vm._e(),
      _vm.titleImg
        ? _c(
            "div",
            { staticClass: "title-img", class: _vm.customerCss },
            [_vm._t("img")],
            2
          )
        : _vm.titleImg2
        ? _c(
            "div",
            { staticClass: "title-img2", class: _vm.customerCss },
            [_vm._t("img2")],
            2
          )
        : _vm.titleImg3
        ? _c(
            "div",
            { staticClass: "title-img3", class: _vm.customerCss },
            [_vm._t("img3")],
            2
          )
        : _vm._e(),
      _vm.tabs ? _c("div", [_vm._t("tab")], 2) : _vm._e(),
      _vm.subtitle
        ? _c("div", { staticClass: "title" }, [
            _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t(_vm.subtitle)) } })
          ])
        : _vm._e(),
      _vm.h3title
        ? _c("div", { staticClass: "title mtop-8" }, [
            _c("h3", { domProps: { innerHTML: _vm._s(_vm.$t(_vm.h3title)) } })
          ])
        : _vm._e(),
      _vm.description3
        ? _c("div", {
            staticClass: "description3",
            domProps: { innerHTML: _vm._s(_vm.$t(_vm.description3)) }
          })
        : _vm._e(),
      _vm._t("card"),
      _vm._t("summary")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }